import type React from 'react';

import { JsonSchemaInput } from '@ragu-components/json-schema-input';
import {
  OrdFormList,
  OrdIconStandard,
  OrdReferenceInput,
  OrdTabbedForm,
  useDeleteProps,
} from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { UserNumberUpdateFields, dataSchema } from '@ragu-components/ord-types';
import { TabbedForm } from 'react-admin';

import { OrdDescriptionInput } from 'src/components/formInputs';

import type { OrdTabbedFormProps } from '@ragu-components/ord-components';
import type { UserNumber } from '@ragu-components/ord-types';

/**
 * Renders the UserNumbersForm component.
 * If the embedded prop is true, the owner field will be disabled.
 *
 * @param {OrdTabbedFormProps & { embedded?: boolean }} props - The props for the UserNumbersForm component
 * @return {React.ReactElement} The rendered UserNumbersForm component
 */
export const UserNumbersForm = ({
  embedded = false,
  ...props
}: OrdTabbedFormProps & { embedded?: boolean }): React.ReactElement => {
  return (
    <OrdTabbedForm
      sanitizeFields
      replaceRelationships
      createJsonSchema={dataSchema.UserNumberCreate}
      editJsonSchema={dataSchema.UserNumberUpdate}
      deleteProps={{ ...useDeleteProps<UserNumber>((record) => record.number), redirect: false }}
      syncWithLocation={false}
      {...props}
    >
      <TabbedForm.Tab label='resources.user_numbers.operations.sections.details'>
        <OrdFormList icon={<OrdIconStandard name='numbers' />}>
          <JsonSchemaInput source={UserNumberUpdateFields.number} />
        </OrdFormList>
        <OrdFormList icon={<OrdIconStandard name='description' />}>
          <OrdDescriptionInput source={UserNumberUpdateFields.description} />
        </OrdFormList>
        <OrdFormList icon={<OrdIconStandard name='person' />}>
          <OrdReferenceInput readOnly={embedded} source={UserNumberUpdateFields.owner} resource={Resources.users} />
        </OrdFormList>
      </TabbedForm.Tab>
    </OrdTabbedForm>
  );
};
